module.exports = __webpack_public_path__ + "img/ico-halekulani.f30ad2f9.png";